import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { withStyles } from 'material-ui/styles'
import { computed, action, observable } from 'mobx'
import moment from 'moment'
import { TREE_EVENT, MANAGER_EVENT } from 'shared/dictionaries/events'

import Dialog, { DialogContent } from 'material-ui/Dialog'
import AppBar from 'material-ui/AppBar'
import Toolbar from 'material-ui/Toolbar'
import IconButton from 'material-ui/IconButton'
import Typography from 'material-ui/Typography'
import { Close, ArrowLeft } from 'mdi-material-ui'
import Slide from 'material-ui/transitions/Slide'
import Datepicker from 'shared/components/Datepicker'
import withAppStore from 'decorators/withAppStore'
import Search from 'components/Search'
import styles from 'styles/components/NodeInfo'
import Direction from 'components/Direction'
import ClearanceCountry from 'components/ClearanceCountry'
import OriginCountry from 'components/OriginCountry'
import Code from 'components/Code'

const INFO_WIDGET_BASE_URL = process.env.REACT_APP_INFO_WIDGET_URL

@withStyles(styles)
@withAppStore
@observer
export default class NodeInfo extends Component {
  constructor(params) {
    super(params)
    this.breakpoint = 700
    this.state = {
      isMobile: window.innerWidth <= this.breakpoint,
    }
  }

  @observable iframe = null

  @computed
  get iframeUrl() {
    const {
      theme,
      onDate,
      infoCode,
      dataStore,
      apiKey,
      dominantMode,
      treeLink,
      direction,
      clearanceCountry,
      originCountry,
    } = this.appStore

    const params = {
      theme: theme.palette.type,
      code: infoCode,
      type: dataStore.toString(),
      date: (onDate || moment()).format('DD-MM-YYYY'),
      direction: direction,
      clearanceCountry: clearanceCountry,
      originCountry: originCountry,
      collapsed: false,
      'show-title': false,
      'api-key': apiKey,
      'dominant-mode': dominantMode,
      'tree-link': treeLink,
    }
    const paramsString = Object.entries(params)
      .map(([key, value]) => `${key}=${value}`)
      .join('&')
    return `${INFO_WIDGET_BASE_URL}/#${paramsString}`
  }

  @computed
  get isOpen() {
    const { infoCode, disableInfo, dataStore } = this.appStore
    return dataStore.isInfoSupported && !disableInfo && !!infoCode
  }

  render() {
    const { classes } = this.props
    const { closeType, direction, clearanceCountry, originCountry, infoCode } = this.appStore
    return (
      <Dialog
        fullScreen
        open={this.isOpen}
        onClose={this.handleClose}
        transition={Transition}
      >
        <AppBar color="default" elevation={1}>
          <Toolbar className={classes.toolbar}>
            {closeType.isBack && (
              <IconButton onClick={this.handleClose} aria-label="Close">
                <ArrowLeft />
              </IconButton>
            )}
            <div className={classes.fullWidth}>
              <Search isMobile={this.state.isMobile} />
            </div>
            <div className={classes.fullWidth}>
              {!this.state.isMobile && (
                <Typography color="inherit" className={classes.header}>
                  Справка по коду <Code code={infoCode} />
                </Typography>
              )}
            </div>
            <Direction direction={direction} isMobile={this.state.isMobile} />
            <ClearanceCountry
              clearanceCountry={clearanceCountry}
              isMobile={this.state.isMobile}
            />
            {<OriginCountry
              originCountry={originCountry}
              isMobile={this.state.isMobile}
              direction={direction}
            />}
            <div className={classes.fullWidth}>

            </div>

            <Datepicker isMobile={this.state.isMobile} />

            {closeType.isClose && (
              <IconButton onClick={this.handleClose} aria-label="Close">
                <Close />
              </IconButton>
            )}
          </Toolbar>
        </AppBar>

        <DialogContent className={classes.content}>
          <iframe
            src={this.iframeUrl}
            width="100%"
            height="100%"
            seamless
            scrolling="no"
            frameBorder="no"
            title="QBorder Info Widget"
            ref={(iframe) => {
              this.iframe = iframe
            }}
          />
        </DialogContent>
      </Dialog>
    )
  }

  componentDidUpdate() {
    const { infoCode, expandedNodes, isBlink } = this.appStore
    this.registerOrigin()
    if (isBlink) {
      if (infoCode === null && expandedNodes) {
        this.scrollExpanded(expandedNodes)
      }
      this.appStore.isBlink = false
    } else {
      if (infoCode !== null) {
        this.appStore.isBlink = true
      }
    }
  }

  componentDidMount() {
    this.registerOrigin()
    window.addEventListener('message', this.infoEvent.bind(this), false)
    window.addEventListener('resize', this.handleResizeWindow.bind(this))
    this.handleResizeWindow()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResizeWindow)
    window.removeEventListener('message', this.infoEvent)
  }

  handleResizeWindow = () => {
    this.setState({
      isMobile: window.innerWidth <= this.breakpoint,
    })
  }

  registerOrigin() {
    window.setTimeout(() => {
      if (!this.iframe) return
      const origin = this.appStore.widgetOrigin ? this.appStore.widgetOrigin : this.appStore.treeLink;
      const details = { origin }
      const name = MANAGER_EVENT.REGISTER_ORIGIN
      const message = { name, details }
      this.iframe.onload = () => {
        this.iframe.contentWindow.postMessage(message, '*')
      }
    }, 0)
  }

  scrollExpanded(expandedNodes) {
    if (expandedNodes.length !== 0) {
      const nodeId = Number.parseInt(expandedNodes[expandedNodes.length - 1], 0)
      const { items } = this.appStore.treeStore.nodes
      let node = items.find((node) => node.id === nodeId)
      if (node) {
        this.handleNodeClick(node, nodeId)
      } else {
        node = items.find(
          (node) => node.id === Number.parseInt(expandedNodes[0], 0),
        )
        if (node) {
          this.handleNodeClick(node, nodeId)
        }
      }
    }
  }

  @action.bound
  async handleNodeClick(node, nodeId) {
    node.isLoading = true
    await node.restoreBranch()
    node.isLoading = false
    this.handleClose()
    if (this.appStore.infoCode !== null) {
      this.appStore.infoCode = null
      this.appStore.sendEvent(TREE_EVENT.CLOSE_INFO)
    }
    const treeNode = this.appStore.dataStore.nodes.get(nodeId)
    if (treeNode) {
      this.appStore.scrollToNode(treeNode)
      treeNode.flash()
    }
  }

  @action.bound
  handleClose() {
    this.appStore.infoCode = null
    this.appStore.sendEvent(TREE_EVENT.CLOSE_INFO)
    this.appStore.isBlink = false
  }

  @action.bound
  infoEvent(event) {
    if (event.origin !== INFO_WIDGET_BASE_URL) {
      return
    }
    if (event.data['name'] === 'info-close') {
      this.handleClose()
      if (event.data['details']) {
        window.open(event.data['details'], '_top')
      }
    }
  }
}

function Transition(props) {
  return <Slide direction="up" {...props} />
}



// WEBPACK FOOTER //
// ./src/components/NodeInfo.js